// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"6dbf2731","388":"6459760c","722":"cd61af90","798":"6459760c","933":"754362ac"}[chunkId] + ".chunk.css";
};